import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { FN_GENERATION__update_locally } from '../_methods/FN_GENERATION__update_locally';
import { STATE__generation } from '../STATE__generation';

export const REMOTE__generation_update_graph = createAsyncThunkSafe<void, DTO_GRAPH__instance>(
  ENUM__network_event_client_to_server.GENERATION_UPDATE_GRAPH,
  async (graph: DTO_GRAPH__instance): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.GENERATION_UPDATE_GRAPH, graph);
  },
);

export function INIT_REMOTE__generation_update_graph(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(REMOTE__generation_update_graph.pending, (state, action) => {
      let graph = action.meta.arg;
      FN_GENERATION_try_update_generation_current_graph(state, graph);
    })
    .addCase(REMOTE__generation_update_graph.rejected, (state, action) => {})
    .addCase(REMOTE__generation_update_graph.fulfilled, (state, action: PayloadAction) => {});
}

function FN_GENERATION_try_update_generation_current_graph(state: STATE__generation, graph: DTO_GRAPH__instance) {
  if (state.generation_current._id != graph.meta.graph_id) return;

  let generation_current = state.generation_current.clone();

  generation_current.tool.graph = graph.clone();

  //clone needs to force rerender generation current
  FN_GENERATION__update_locally(state, generation_current);
}
